import axios from 'axios';
import constants from '../constants';

export class Api {
  constructor({
    withCredentials = true,
    contentType = 'application/json',
    ...config
  }) {
    this.axiosInstance = axios.create({ withCredentials, contentType, ...config });
  }

  request(type, url, body) {
    if (!this.axiosInstance.defaults.baseURL) throw("No baseURL set for API.");

    return new Promise((resolve, reject) => {
      this.axiosInstance[type](url, body)
        .then((res) => resolve(res.data))
        .catch((error) => reject(error.response));
    });
  }

  configure({ baseURL }) {
    this.axiosInstance.defaults.baseURL = baseURL;
  }

  get(url) {
    return this.request('get', url);
  }

  post(url, body = {}) {
    return this.request('post', url, body);
  }

  put(url, body = {}) {
    return this.request('put', url, body);
  }

  delete(url, body = {}) {
    return this.request('delete', url, body);
  }
}

Api.defaultInstance = new Api({ baseURL: constants.apiRoot });

export default Api.defaultInstance;
